// Taşeron portalı — ad token karşılaştırması (S19-D8, sapma YOK). Eskiden
// `DocumentAnalysisConflictCard.tsx`'te yaşıyordu; o dosya C14'te SİLİNDİ. S25 C8 bunu kalıcı
// bir eve TAŞIMIŞTI — `AnalysisReviewPane.tsx` (uyuşmazlık uyarısı, `lib/personMatch.ts`
// üzerinden) BURADAN import eder.
//
// Karşılaştırıcı TAM OLARAK şu şekildedir (S19-D8, sapma YOK):
//   `toLocaleUpperCase('tr')` iki tarafta da (`toUpperCase()` DEĞİL — `İnci` → `İNCİ` yerine
//   `İNCI`'ye döner ve `İNCİ` ile eşleşmeyi durdurur) → harf-dışı karakterleri temizle → boşlukla
//   böl → iki token kümesi HİÇ ortak token PAYLAŞMIYORSA çakışma. Herhangi bir ortak token varsa
//   eşleşme satırı (çakışma DEĞİL). Az-tetikleme güvenli yöndür: doküman hacminin %80-90'ını
//   oluşturan sınıfta yanlış bir çakışma güvensizlik öğretir; kaçırılan biri İSG uzmanının
//   göreceği ve sileceği yanlış bir belgeye mal olur.

/** Ad token kümesi — S19-D8'in tanımı, harfiyen. `\p{L}` Türkçe aksanlı harfleri de kapsar. */
export function nameTokens(name: string): Set<string> {
  return new Set(
    name
      .toLocaleUpperCase('tr')
      .replace(/[^\p{L}\s]/gu, ' ')
      .split(/\s+/)
      .filter((token) => token.length > 0),
  );
}

/** `true` yalnız iki ad HİÇ ortak token paylaşmıyorsa (S19-D8). Boş ad → asla çakışma (karşılaştıracak bir şey yok). */
export function namesConflict(readName: string, pageName: string): boolean {
  const a = nameTokens(readName);
  const b = nameTokens(pageName);
  if (a.size === 0 || b.size === 0) {
    return false;
  }
  for (const token of a) {
    if (b.has(token)) {
      return false;
    }
  }
  return true;
}
